import yup from '../../Utils/yup';

export const loginFormRules = yup.object().shape({
  username: yup.string().required(),
  password: yup.string().strongPassword().required()
});
